<script>
import Footer from "@/components/restrito/Footer.vue";
import PostList from "@/components/restrito/PostList.vue";
import Sidebar from "@/components/restrito/Sidebar.vue";
import Navbar from "@/components/restrito/Navbar.vue";

export default {
  components: { Footer, PostList, Sidebar, Navbar },
};
</script>

<template>
  <v-app>
    <Navbar :voltar="false" app />
    <Sidebar />
    <v-main style="background-color: #f5f5f5">
      <PostList />
    </v-main>
    <Footer />
  </v-app>
</template>

<style>
.v-main {
  background-color: #f5f5f5;
}
</style>
